import DownloadPopup from "components/core/modal-components/DownloadPopup";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import {
  ERROR_TYPES,
  VALUE_EMPTY_STRING,
  downloadOptionPdf
} from "utils/constants";
import {
  dataDogErrorLog,
  escapeXmlForReport,
  findErrorMessage,
  getUserName,
  handleRefId,
  printReport
} from "utils/helpers";

export default function DownloadReportModal({
  isVisible,
  setIsVisible,
  mainDistrictId,
  setIsLoading,
  districtName,
  systemId,
  languageLocaleId,
  destructRequestId,
  customerId,
  pickupInstructions,
  throwError,
  setThrowError,
  throwErrorMessage,
  setThrowErrorMessage
}) {
  const { auth } = useSelector(selectAuth);
  const { t } = useTranslation();
  const [reportCUrl, setReportCFUrl] = useState(VALUE_EMPTY_STRING);
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);

  useEffect(() => {
    if (isVisible) {
      setReportCFUrl(CF_URLS.printReports.request.mdrPickupReport);
    } else {
      setReportCFUrl(VALUE_EMPTY_STRING);
    }
  }, [isVisible]);

  //handle download
  const handleDownload = async () => {
    try {
      setIsLoading(true);
      setThrowError(false);
      const reqBody = JSON.stringify({
        main_district_id: mainDistrictId,
        user_name: getUserName(auth?.user),
        destruct_request_id: destructRequestId,
        system_id: systemId,
        customer_id: customerId,
        language_locale_id: languageLocaleId,
        pickup_instruction_comment: escapeXmlForReport(pickupInstructions),
        last_mod_user: VALUE_EMPTY_STRING,
        district_name: districtName,
        report_format: selectedValue?.type?.toUpperCase()
      });
      let reportResponse = await printReport(
        reqBody,
        `${CF_URLS.printReports.request.mdrPickupReport}`
      );
      if (!reportResponse.success) {
        setThrowErrorMessage(reportResponse.error);
        setThrowError(true);
      }
    } catch (e) {
      const { refId, message } = handleRefId(
        e.message || findErrorMessage(ERROR_TYPES.ISSUE)
      );
      dataDogErrorLog(message, "", { error: e }, refId);
      setThrowErrorMessage(message);
      setThrowError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setThrowError(false);
    setIsVisible(false);
  };

  return (
    <DownloadPopup
      title={t("common.downloadReport")}
      showPrintModal={isVisible}
      onCancleClick={handleCancel}
      onDownloadClick={handleDownload}
      setSelectedValue={setSelectedValue}
      setThrowError={setThrowError}
      throwError={throwError}
      throwErrorMessage={throwErrorMessage}
      cfUrl={reportCUrl}
    />
  );
}
